import { CSSProperties } from "react";
import * as React from "react";
import { Button } from "./buttons/Button";
import Icon from "./Icon";
import { AdvancedTooltip } from "./tooltips/AdvancedTooltip";
import { TTFirstPage } from "./tooltips/docViewer/TTFirstPage";
import { TTLastPage } from "./tooltips/docViewer/TTLastPage";
import { TTNextPage } from "./tooltips/docViewer/TTNextPage";
import { TTPopoutButton } from "./tooltips/docViewer/TTPopoutButton";
import { TTPrevPage } from "./tooltips/docViewer/TTPrevPage";
import "../styles/docViewer/docViewerButtons.css";

type Props = {
  /**
   * Sends -1 if it should go to the last page.
   */
  changeIndex: (index: number) => void;
  shiftPageByOne: (increment: boolean) => void;
  /* Call to change whethere spans visible */
  showSpans: boolean;
  showSpansFn?: VoidFunction;
  popOut?: VoidFunction;
  poppedOut?: boolean;
  style?: CSSProperties;
};

const DocumentViewerHeaderButtons = (props: Props) => {
  return (
    <span
      style={props.style}
      onClick={(e: React.MouseEvent<HTMLSpanElement, MouseEvent>) =>
        e.stopPropagation()
      }
    >
      {/* Item 20 */}
      <span className={"noselect"}>
        <AdvancedTooltip short tooltipText={() => "First Page"}>
          {(tProps) => (
            <Button
              {...tProps}
              className={"p-5 docViewerButton"}
              onClick={() => props.changeIndex(0)}
            >
              <Icon altText={""} icon={"angle-double-left"} />
            </Button>
          )}
        </AdvancedTooltip>
        <AdvancedTooltip short tooltipText={() => "Previous Page"}>
          {(tProps) => (
            <Button
              {...tProps}
              className={"p-5 docViewerButton"}
              onClick={() => props.shiftPageByOne(false)}
            >
              <Icon altText={""} icon={"angle-left"} />
            </Button>
          )}
        </AdvancedTooltip>
        <AdvancedTooltip short tooltipText={() => "Next Page"}>
          {(tProps) => (
            <Button
              {...tProps}
              className={"p-5 docViewerButton"}
              onClick={() => props.shiftPageByOne(true)}
            >
              <Icon altText={""} icon={"angle-right"} />
            </Button>
          )}
        </AdvancedTooltip>
        <AdvancedTooltip short tooltipText={() => "Last Page"}>
          {(tProps) => (
            <Button
              {...tProps}
              className={"p-5 docViewerButton"}
              onClick={() => props.changeIndex(-1)}
            >
              <Icon altText={""} icon={"angle-double-right"} />
            </Button>
          )}
        </AdvancedTooltip>
      </span>
      {props.showSpansFn && (
        <AdvancedTooltip short tooltipText={() => "Highlight Spans"}>
          {(tProps) => (
            <Button
              {...tProps}
              style={{ marginLeft: 10 }}
              className={"p-5 docViewerButton"}
              onClick={() => props.showSpansFn!()}
            >
              <Icon
                altText={``}
                icon={!props.showSpans ? "eye" : "eye-slash"}
              />
            </Button>
          )}
        </AdvancedTooltip>
      )}
      {props.popOut && (
        // Item 19
        <AdvancedTooltip
          short
          tooltipText={() => (
            <p>Click to open the document viewer in a separate window.</p>
          )}
        >
          {(tProps) => (
            <Button
              {...tProps}
              style={{ marginLeft: 10 }}
              className={"p-5 docViewerButton"}
              onClick={() => props.popOut!()}
            >
              <Icon altText={``} icon={"external-link-square-alt"} />
            </Button>
          )}
        </AdvancedTooltip>
      )}
    </span>
  );
};

export default DocumentViewerHeaderButtons;
